import { apiRequest } from './api';
import { DashboardStats, RevenueChart, ClientStatusChart } from '../types';
import { AlertaTrocaOleo } from '../types/frota';

export const dashboardService = {
  // Obter estatísticas gerais do dashboard
  getStats: async (): Promise<DashboardStats> => {
    const response = await apiRequest.get<DashboardStats>('/dashboard/stats');
    return response.data!;
  },

  // Obter dados do gráfico de receita
  getRevenueChart: async (): Promise<RevenueChart[]> => {
    const response = await apiRequest.get<RevenueChart[]>('/dashboard/revenue-chart');
    return response.data!;
  },

  // Obter dados do gráfico de status dos clientes
  getClientStatusChart: async (): Promise<ClientStatusChart[]> => {
    const response = await apiRequest.get<ClientStatusChart[]>('/dashboard/client-status-chart');
    return response.data!;
  },

  getPerformanceChart: async () => {
    try {
      const response = await apiRequest.get<any[]>('/dashboard/performance-chart');
      return response.data;
    } catch (error: any) {
      return { success: false, data: [], error: error.message };
    }
  },

  /** Quantidade de contrato_serviços por plano (contrato não cancelado) */
  getContratoServicosPorPlano: async (): Promise<{ plano_id: number | null; nome: string; quantidade: number }[]> => {
    try {
      const response = await apiRequest.get<{ plano_id: number | null; nome: string; quantidade: number }[]>(
        '/dashboard/contrato-servicos-por-plano'
      );
      return response.data ?? [];
    } catch {
      return [];
    }
  },

  getRegistrationsCancellationsChart: async () => {
    try {
      const response = await apiRequest.get<any[]>('/dashboard/registrations-cancellations-chart');
      return response.data;
    } catch (error: any) {
      return { success: false, data: [], error: error.message };
    }
  },

  getOverdueClientsChart: async () => {
    try {
      const response = await apiRequest.get<any[]>('/dashboard/overdue-clients-chart');
      return response.data;
    } catch (error: any) {
      return { success: false, data: [], error: error.message };
    }
  },

  getAlertasTrocaOleo: async (limiteKm = 100): Promise<AlertaTrocaOleo[]> => {
    try {
      const response = await apiRequest.get<AlertaTrocaOleo[]>(`/dashboard/alertas-troca-oleo?limite_km=${limiteKm}`);
      return response.data ?? [];
    } catch {
      return [];
    }
  },

  getComoConheceuChart: async (dataInicio?: string, dataFim?: string): Promise<{ origem: string; quantidade: number }[]> => {
    try {
      const params: any = {};
      if (dataInicio) params.data_inicio = dataInicio;
      if (dataFim) params.data_fim = dataFim;
      const response = await apiRequest.get<{ origem: string; quantidade: number }[]>('/dashboard/como-conheceu-chart', { params });
      return response.data ?? [];
    } catch {
      return [];
    }
  },
}; 